<template>
  <v-container v-if="assertSetting('personReserve', 1)">
    <h2>Other Charges</h2>
    <v-layout
      justify-space-between
      row>
      <v-flex class="px-2">
        <v-select
          v-model="otherChargeForm.accountEntryTypeID"
          :items="otherChargeAccounts"
          item-text="name"
          item-value="account"
          label="Revenue Stream"
        />
      </v-flex>
      <v-flex class="px-2">
        <v-text-field
          v-model="otherChargeForm.note"
          label="note"
        />
      </v-flex>
      <v-flex class="px-2">
        <v-currency-field
          v-model="otherChargeForm.retailPrice"
          label="Amount"
        />
      </v-flex>
      <v-btn
        @click="createOtherCharge(otherChargeForm)"
      >
        Add
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

export default {
  name: 'VehicleForm',
  data () {
    return {
      otherChargeForm: {
        accountEntryTypeID: null,
        note: null,
        retailPrice: null
      },
      otherChargeAccounts: [
        {
          name: 'Bunk House',
          account: 'bunkhouse'
        },
        {
          name: 'Transfer Fee',
          account: 'transferFee'
        },
        {
          name: 'Processing Fee',
          account: 'processingFee'
        },
        {
          name: 'Media Permit',
          account: 'mediaPermit'
        },
        {
          name: 'Books',
          account: 'books'
        },
        {
          name: 'Maps',
          account: 'maps'
        },
        {
          name: 'Propane',
          account: 'propane'
        },
        {
          name: 'Canoes',
          account: 'canoes'
        },
        {
          name: 'Firewood',
          account: 'firewood'
        },
        {
          name: 'Other',
          account: 'other'
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      createOtherCharge: 'cart/createOtherCharge'
    })
  }
}
</script>
